export function formatDuration(value, format = 'mm:ss') {
  if (value === undefined || value === null) {
    return '';
  }
  if (format === 'mm:ss') {
    const minutes = Math.floor(value / 60);
    const seconds = Math.floor(value % 60);
    return `${formatAs2Digits(minutes)}:${formatAs2Digits(seconds)}`;
  } else if (format === 'mm:ss:mmm') {
    const minutes = Math.floor(value / 60);
    const seconds = Math.floor(value % 60);
    const ms = Math.floor((value - seconds) * 1000);
    return `${formatAs2Digits(minutes)}:${formatAs2Digits(seconds)}.${formatAs3Digits(ms)}`;
  } else if (format === 'mm') {
    const minutes = Math.floor(value / 60);
    return `${formatAs2Digits(minutes)}`;
  }
}
function formatAs2Digits(value) {
  return value < 10 ? '0' + value : value.toString();
}
function formatAs3Digits(value) {
  if (value < 10) return '00' + value;
  if (value < 100) return '0' + value;
  return '' + value;
}